<template>
  <div>
    <div class="container">
      <CtaArrow
        :to="{ name: `knowledge-index-topic___${$i18n.locale}`, topic: entry.slug }"
        :reverse="true"
        class="inline-block mt-12"
        >{{ $t('knowledge.backToTitle', { title: entry.title }) }}</CtaArrow
      >
      <h1 class="fluid-xl leading-tight font-medium">{{ entry.title }} {{ $t('knowledge.articles') }}</h1>
    </div>
    <div class="container">
      <ArticleList :articles="articles" class="mt-12" />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { EntryPageFragment } from '@/mixins/entryPage';
import topicPage, { TopicBaseFragment } from '@/mixins/topicPage';
import { RelatedArticlesQuery } from '@/mixins/knowledgeCategoryPage';
import ArticleList from '@/components/article/ArticleList';
import CtaArrow from '@/components/common/CtaArrow';

const TopicArticlesQuery = gql`
  query TopicArticlesQuery($site: String!, $topic: String!) {
    entry(site: [$site], slug: [$topic], section: "knowledge") {
      ...EntryPageFragment
      ...TopicBaseFragment
    }
  }
  ${EntryPageFragment}
  ${TopicBaseFragment}
`;
export default defineNuxtComponent({
  name: 'TopicArticles',

  components: { ArticleList, CtaArrow },

  mixins: [topicPage],

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const { locale } = useNuxtApp().$i18n;
    const route = useRoute();
    const { topic } = route.params;
    const variables = { site: locale.value, topic };

    const { entry } = await $craftRequest(TopicArticlesQuery, variables);

    if (!entry) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
      });
    }

    const relatedVariables = { site: locale.value, related: [entry.id] };
    const { entries: articles } = await $craftRequest(RelatedArticlesQuery, relatedVariables);

    return { entry, articles };
  },

  data() {
    return {
      entry: null,
      articles: [],
    };
  },

  mounted() {
    this.setTopicCategories();
    this.$emit('onSetChildBreadCrumb', this.buildBreadCrumb());
    this.gtmPushPageMeta({
      page_type: 'topicArticles',
      content_category: 'knowledge',
      content_subcategory: this.entry?.slug,
    });
  },

  methods: {
    buildBreadCrumb() {
      return [
        {
          label: this.entry.title,
          route: {
            name: `knowledge-index-category-slug___${this.$i18n.locale}`,
            params: { topic: this.entry.slug },
          },
        },
        {
          label: 'all Articles',
          route: {
            name: `knowledge-index-topic-articles___${this.$i18n.locale}`,
            params: { topic: this.entry.slug },
          },
        },
      ];
    },
  },
});
</script>
